module.exports = __webpack_public_path__ + "img/etp.061d85c3.svg";